import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useLazyRestQuery from "@/remoteState/useLazyRestQuery";
import { ContentPromotionFormResponse } from "@/types/models/ContentPromotionFormResponse.interface";

const useLazyContentPromotionFormResponsesGet = (formId: string) => {
  const requestUrl = `${MONOLITH_ORIGIN}/api/v3/platform-alignment-form-response/?form_id=${formId}`;
  return useLazyRestQuery(requestUrl, { skip: !formId }) as [
    () => void,
    {
      data: ContentPromotionFormResponse[] | undefined;
      error: Error;
      loading: boolean;
    },
  ];
};

export default useLazyContentPromotionFormResponsesGet;
